<template>
    <div
        class="md-area-overview layout2 mg-bg"
        :style="{
            ...spaceStyle,
            ...colorStyle,
        }"
    >
        <div class="area-overview-container mg-container">
            <media-content
                class="f-col"
            >
                <template #info>
                    <site-title
                        :title="areaInfo.name"
                        align="center"
                        :size="70"
                        :mbSize="35"
                    />
                    <site-sub-title
                        :title="subTitle"
                        align="center"
                        :size="34"
                        :mbSize="20"
                    />
                    <div class="banner-container">
                        <site-img
                            class="banner-img"
                            :src="suitableImg"
                            dir="height"
                            :size="1000"
                        />
                        <div class="info-tags" v-if="suitableTags && suitableTags.length > 0">
                            <div class="tag-item" v-for="(tag, index) in suitableTags" :key="index">{{ tag.label }}</div>
                        </div>
                    </div>
                    <div class="banner-content" v-if="suitableDesc">
                        <ViewMore
                            :mode="isMobileSize ? 'bottom-center' : 'end'"
                            :line="4"
                            :mobileLine="4"
                            :content="suitableDesc"
                            :moreText="$t('common:viewMore.showMore')"
                            :lessText="$t('common:viewMore.showLess')"
                        />
                    </div>
                </template>
            </media-content>
            <div class="data-overview f-col" :style="bgStyle">
                <div class="data-list" v-animated-number="{ duration: 3000, selector: '.item-price', enable: showAnimationEffects }">
                    <div class="data-item" v-for="item in overviewList" :key="item.type">
                        <div class="item-left">
                            <i class="iconfont" :class="item.icon"></i>
                        </div>
                        <div class="item-right" :style="btnStyle">
                            <div class="item-label">{{ item.label }}</div>
                            <div class="item-price">{{ item.value }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import common from '../index.js';
export default {
    mixins: [common],
}
</script>

<style lang="scss">
@import '@/theme/media.scss';
@import '@/theme/mixin.scss';
.md-area-overview.layout2 {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    .area-overview-container {
        position: relative;
    }
    .site-title {
        line-height: 1;
        margin-bottom: 20px;
        margin-top: 40px;
    }
    .site-subtitle {
        line-height: 1;
        margin-bottom: 40px;
        color: var(--g-primary-color);
    }
    .media-content-v2 {
        .media-info {
            width: 100%;
        }
    }
    
    .banner-img {
        height: 500px;
        width: 100%;
        object-fit: cover;
    }
    .banner-content {
        margin-top: 30px;
        .view-more {
            .view-more-content {
                font-size: 18px;
                color: var(--g-primary-color);
                line-height: 27px;
                display: flex;
                flex-direction: column;
            }
            .more-btn {
                line-height: 27px;
                background: var(--g-bg-color, #fff);
                &:hover {
                    color: var(--g-btn-background, #4c84ff);
                }
            }
        }
    }
    .banner-container {
        position: relative;
        width: 100%;
        height: 100%;
    }
    .info-tags {
        position: absolute;
        bottom: 20px;
        left: 20px;
        display: flex;
        gap: 5px;
        justify-content: flex-start;
        flex-wrap: wrap;
        .tag-item {
            font-size: 14px;
            line-height: 1.5;
            padding: 2px 10px;
            background: rgba(25, 25, 25, 0.6);
            color: #fff;
        }
    }
    .data-overview {
        padding: 40px 0 17px;
        .data-list {
            display: flex;
            gap: 30px;
        }
        .data-item {
            flex: 1;
            display: flex;
            align-items: center;
            background: rgba(25, 25, 25, 0.05);
            padding: 29px 62px 30px 30px;
            border: 1px solid rgba(218, 218, 218, 0.5);
            .item-left {
                display: flex;
                justify-content: center;
                align-items: center;
                color: var(--g-text-color);
                .iconfont {
                    font-size: 28px;
                    margin-right: 12px;
                }
            }
            .item-right {
                display: flex;
                flex-direction: column;
                color: var(--g-primary-color);
                gap: 5px;
                .item-price {
                    font-size: 16px;
                    line-height: 1.5;
                    font-family: var(--font-medium);
                }
                .item-label {
                    font-size: 12px;
                    color: var(--g-text-color);
                    line-height: 1.6;
                }
            }
        }
    }
    @include media-800 { 
        .banner-container {
            height: 200px;
        }
        .banner-img { 
            height: 100%;
        }
        .info-tags { 
            bottom: 10px;
            left: 10px;
            .tag-item {
                font-size: 12px;
            }
        }
        .site-title {
            font-size: 35px;
            margin-top: 0px;
            margin-bottom: 20px;
        }
        .site-subtitle {
            margin-bottom: 20px;
        }
        .banner-content {
            margin-top: 20px;
        }

        .data-overview {
            padding: 20px 0px 0px;
            .data-list {
                display: flex;
                flex-direction: column;
                gap: 20px;
            }
        }
    }
}
</style>